/* eslint-disable no-unused-vars */
import React from "react"
import { BrowserRouter as Router } from "react-router-dom"
import { Scoped } from "kremling"
import styles from "../root.krem.css"
import VisionContainer from "./VisionContainer"
import Icon from "./AdminDashboardContainer/components/Icon"

export default class Vision extends React.Component {
  state = {
    hasError: false
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true })
  }

  render() {
    const { hasError } = this.state
    const css = `
      .center {
        margin: auto;
        padding: 10px;
        width: 50%;
      }
      .center-text {
        display: table;
        margin: 0 auto;
      }
      .error-header-text{
        font-family: inherit;
        color: #1D1E1F;
        font-size: 18px;
        font-weight: bold;
        line-height: 24px;
        margin-bottom: 5px;
      }
      .error-text {
        font-family: inherit;
        color: #565D66;
        font-size: 14px;
        font-weight: 300;
        line-height: 24px;
        text-align: center;
      }
      .error-large-width {
        width: 425px;
      }
      .error-text-top {
        margin-top: 15px;
      }
    `
    return (
      <Scoped postcss={styles}>
        {hasError ? (
          <div
            id="vision-dashboard"
            style={{
              position: "absolute",
              left: "270px",
              height: "100%",
              overflow: "auto",
              right: 0,
              padding: "16px 48px"
            }}
          >
            <style>{css}</style>
            <div className="error-width">
              <div className="center error-large-width">
                <Icon name="error" />
                <div className="error-large-width error-text-top">
                  <div className="center-text error-header-text">
                    Oh no, something&apos;s gone awry...
                  </div>
                  <div className="center-text error-text">
                    Sorry about that! Our team has been notified of the issue.
                    In the meantime, please try refreshing the page or coming
                    later.
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Router>
            <div
              id="vision-dashboard"
              style={{
                position: "absolute",
                left: "270px",
                height: "100%",
                overflow: "auto",
                right: 0,
                padding: "16px 48px"
              }}
            >
              <VisionContainer />
            </div>
          </Router>
        )}
      </Scoped>
    )
  }
}
